<!-- 我的订单 -->
<template>
    <cc-container class="purchase-history">
      <cc-header-nav title="我的订单">
        <template slot="right">
          <cc-svg-icon @click="showDate" icon-class="date" />
        </template>
      </cc-header-nav>
      <cc-main>
        <cc-fade>
          <cc-date-filter
          v-show="dateFilterVisible"
          @search="handleDateFilter"
          @cancel="emptyData"
          ref="dateFilter"
          >
          </cc-date-filter>
        </cc-fade>
      <div class="search-box">
        <input v-model.trim="params.search" class="input-search" type="text" placeholder="订单号">
        <cc-svg-icon @click="toSearch" size='.16rem' class-name='search-icon' icon-class='search'></cc-svg-icon>
      </div>
      <van-tabs class="tabs" v-model="active"  @click="onClick">
        <van-tab title="全部"></van-tab>
        <van-tab title="待审核"></van-tab>
        <van-tab title="已完成"></van-tab>
        <van-tab title="已取消"></van-tab>
      </van-tabs>
      <skeleton v-if="showSkeleton"/>
      <van-list
        v-else
        class="purchase-history-list"
        v-model="m_loading"
        :finished="m_finished"
        :finished-text="m_finishedText"
        @load="mHandlePullUpLoadMore"
        :immediate-check="m_immediateCheck"
      >
        <cc-not-order
          v-if="list.length === 0 && m_loading === false"
          tip="亲，暂无相关订提成明细哦"
          :show="false"
        >
        </cc-not-order>
        <cc-animation-list>
          <order-item
            v-for="(item,index) in list"
            :key="index"
            :item="item"
            @showPopupHandler="showPopupHandler"
          >
          </order-item>
        </cc-animation-list>
      </van-list>
      </cc-main>
      <cc-footer>
        <cc-nav></cc-nav>
      </cc-footer>

    </cc-container>
</template>

<script>
import Vue from 'vue'
import Skeleton from './skeleton.vue'
import OrderItem from './item.vue'
import { Lazyload, List, Tab, Tabs, Popup } from 'vant'
import { loadDistributorOrder } from '~fetch/manage-center/myorder'
import ListMixin from '@/mixins/list'
Vue.use(List)
  .use(Lazyload)
  .use(Tab)
  .use(Tabs)
  .use(Popup)
export default {
  mixins: [ ListMixin ],
  components: {
    Skeleton,
    OrderItem
  },
  data () {
    return {
      showPopup: false,
      showSkeleton: true,
      selectedText: '全部',
      active: 0,
      state: [
        {
          id: '',
          text: '全部',
          selected: true
        },
        {
          id: 1,
          text: '待审核',
          selected: false
        },
        {
          id: 4,
          text: '已完成',
          selected: false
        },
        {
          id: 5,
          text: '已取消',
          selected: false
        }
      ],
      dateFilterVisible: false,
      isShowState: false, // 状态model
      start_time: null,
      end_time: null,
      list: [],
      params: {
        start_time: '',
        end_time: '',
        search: '',
        state: 0
      }
    }
  },

  computed: {},

  created () {
    this.loadData()
  },
  mounted () {

  },

  methods: {
    /**
     * @description 采购订单号搜索
     */
    toSearch () {
      this.search()
    },
    search () {
      this.mReset()
      const reset = true
      this.loadData(reset)
    },
    /**
     * @description 加载数据
     */
    async loadData (reset) {
      if (reset) {
        this.list = []
      }
      this.mRequest()
      const params = this.params
      params.page = this.m_page.curr
      params.page_size = this.m_page.limit
      let res = await loadDistributorOrder(params)
      this.$tips(res, {
        tip: false
      }, res => {
        this.showSkeleton = false
        const data = res
        if (data.order_list.length === 0) {
          this.mEnd()
          if (this.list.length === 0) {
            this.m_finishedText = ''
          }
        } else {
          this.list = [...this.list, ...data.order_list]
        }
      })
      this.mSuccess()
    },
    /**
     * @description 时间筛选
     */
    handleDateFilter ({ startDate, endDate }) {
      this.params.start_time = startDate
      this.params.end_time = endDate
      this.search()
      // this.dateFilterVisible = false
    },
    /**
     * @description 打开时间组件
     */
    showDate () {
      this.isShowState = false
      this.dateFilterVisible = !this.dateFilterVisible
    },
    /**
     * @description 选择状态
     */
    onClick (index, title) {
      this.params.state = this.state[index].id
      this.search()
    },
    /**
     * @description 显示改价popup
     */
    showPopupHandler () {
      this.showPopup = true
    },
    emptyData ({ startDate, endDate }) {
      // 父组件改变子组件的值
      this.$refs.dateFilter.startDate = ''
      this.$refs.dateFilter.endDate = ''
    }
  }
}

</script>
<style lang='scss' scoped>
.purchase-history {
  /deep/{
    .van-icon-plus{
      bottom: -3px;
    }
  }
}
@import '~styles/index.scss';
.search-box{
    border-bottom: 1px solid $border-color-base;
}
.purchase-history {
  @include flex;
  &-item{
  background: #fff;
  }
  .search-box {
    height: 40px;
    position: relative;
    background: #fff;
    @include center(column);
    .input-search {
      height: 28px;
      width: 92%;
      border-radius: 2px;
      border: 1px solid #E5E5E5;
      padding-left: 10px;
      font-size: 12px;
      box-sizing: border-box;
    }
    .search-icon {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: 20px;
    }
  }
  .purchase-history  {
    &-list {
      @include flex(column);
    }
  }
}
.tabs{
  height: 0!important;
  /deep/{
    .van-tab--active{
      color:  var(--APP_theme_color)!important;
    }
    .van-tabs__line{
      background-color: var(--APP_theme_color)!important;
    }
  }
}

</style>
